module.exports = __webpack_public_path__ + "img/xindai_step2.0c639a42.png";